import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import ParallaxLayer from "./ParallaxLayer";

export default class ParallaxContainer extends BaseContainer {

  constructor() {
    super()

    // Block Size: 2450 * 604
    // Static (max) layer width is 2450 * 4
    this.settings = {
      speed: 4.3,
      layers: [
        {
          name: 'Background clouds back',
          speedMultiplier: 0.2,
          type: 'animation',
          gap: -150,
          objects: [
            {
              name: 'thunderClouds',
              repeat: true,
              animations: ['backClouds']
            },
          ]
        },
        {
          name: 'Back layer with slow background rocks',
          speedMultiplier: 0.25,
          gap: 100,
          objects: [
            {name: 'parallax/bgSecABackEl_1', y: 412},
            {name: 'parallax/bgSecBBackEl_1', y: 364},
            {name: 'parallax/bgSecBBackEl_2', y: 364},
          ]
        },
        {
          name: 'Middle layer with big background images',
          speedMultiplier: 1,
          gap: 0,
          objects: [
            {name: 'parallax/bgSecA', scale: 0.5, y: 300},
            {name: 'parallax/bgSecB', scale: 0.5, y: 300},
            {name: 'parallax/bgSecC', scale: 0.5, y: 300},
            {name: 'parallax/bgSecD', scale: 0.5, y: 300},
          ]
        },
        {
          name: 'Background clouds front',
          speedMultiplier: 0.4,
          type: 'animation',
          gap: -150,
          objects: [
            {
              name: 'thunderClouds',
              repeat: true,
              animations: ['frontClouds']
            },
          ]
        },
        {
          name: "Static animations with the same speed and width as the middle layer",
          speedMultiplier: 1,
          type: 'animation',
          layerWidth: 2450 * 4, // Fixed layer width
          objects: [
            {
              name: 'background/valtureAnim', x: 1512, y: 451, scale: 0.5,
              animations: ['valtureIdle', 'valtureWakes'],
            },
            {
              name: 'background/crowAnim', x: 2450 + 833, y: 501, scale: 0.5,
              animations: ['crowIdle', 'crowWakes'],
            },
            {
              name: 'background/wolfAnim', x: 2450 + 300, y: 516, scale: 0.5,
              repeat: true,
              animations: ['animation'],
            },
            {
              name: 'background/undeadsAnim', x: 2450 + 1600, y: 630, scale: 0.5,
              animations: ['animation'],
            },
            {
              name: 'background/hydraAnim', x: 2600 * 2 + 840, y: 503, scale: 0.5,
              animations: ['hydraAnim_Idle', 'hydraAnim_1', 'hydraAnim_2', 'hydraAnim_3', 'hydraAnim_4', 'hydraAnim_5',],
            },
          ]
        },
        {
          name: "First Mist clouds before the front mountains",
          speedMultiplier: 3,
          gap: 300,
          objects: [
            {name: 'parallax/Cloud_2', y: '0-150'},
            {name: 'parallax/Cloud_3', y: '0-150'},
            {name: 'parallax/Cloud_4', y: '0-150'},
            {name: 'parallax/Cloud_5', y: '0-150'},
            {name: 'parallax/Cloud_6', y: '0-150'},
            {name: 'parallax/Cloud_7', y: '0-150'},
          ]
        },
        {
          name: "Second Mist clouds before the front mountains",
          speedMultiplier: 4,
          gap: 200,
          objects: [
            {name: 'parallax/Cloud_2', y: '0-150'},
            {name: 'parallax/Cloud_3', y: '0-150'},
            {name: 'parallax/Cloud_4', y: '0-150'},
            {name: 'parallax/Cloud_5', y: '0-150'},
            {name: 'parallax/Cloud_6', y: '0-150'},
            {name: 'parallax/Cloud_7', y: '0-150'},
          ]
        },
        // {
        //   name: 'Front layer with front mountains',
        //   speedMultiplier: 6,
        //   gap: 500,
        //   objects: [
        //     {name: 'parallax/bgSecAFrontEl_1', y: "464"},
        //     {name: 'parallax/bgSecAFrontEl_1', y: "464"},
        //     {name: 'parallax/bgSecAFrontEl_1', y: "464"},
        //     {name: 'parallax/bgSecAFrontEl_1', y: "464"},
        //   ],
        // }
      ]
    }

    this.parallax = new PIXI.Container()
    this.parallax.name = "Parallax"

    this.addChild(this.parallax)

    this.init(this.settings)
  }

  init(settings) {
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)

    this.layers = settings.layers.map((layerSetting, i) => {
      const layer = new ParallaxLayer(layerSetting, settings)
      this.parallax.addChild(layer)
      return layer
    })
  }

  slow() {
    if (!this.speedStatus || this.speedStatus === 'fast') {
      this.speedStatus = 'slow';
      this.layers.forEach(layer => {
        layer.speed = layer.speed / 2
        if (layer.name === 'First Mist clouds before the front mountains' ||
            layer.name === 'Second Mist clouds before the front mountains') {
          layer.visible = false;
        }
      });
    }
  }

  fast() {
    if (!this.speedStatus || this.speedStatus === 'slow') {
      this.speedStatus = 'fast';
      this.layers.forEach(layer => {
        layer.speed = layer.speed * 2
        if (layer.name === 'First Mist clouds before the front mountains' ||
          layer.name === 'Second Mist clouds before the front mountains') {
          layer.visible = true;
        }
      });
    }
  }

  reset() {
    this.layers.forEach(layer => layer.reset())
  }

  update() {
    this.layers.forEach(layer => layer.move())
  }

  onMakeBets() {
    this.reset()
    Signals.tick.add(this.update, this)
  }

  onRoundEnd() {
    this.speedStatus = null;
    Signals.tick.remove(this.update, this)
  }

  onRoundStart() {
    Signals.tick.add(this.update, this)
  }
}
